module.exports = __webpack_public_path__ + "static/media/22ESCWA11.7813de90.jpg";